<div class="archive-dialog">
  <h2>Archive Schedules</h2>
  <p class="archive-description">
    Soft-delete FracX schedule data before a chosen date.
    Archived schedules will be hidden from all views.
  </p>

  <!-- Company selector (Global Admin only) -->
  <div class="form-row" *ngIf="isGlobalAdmin">
    <label class="field-label">Company</label>
    <select class="field-input" [(ngModel)]="selectedClientId" (change)="reset()">
      <option *ngFor="let c of clients" [value]="c.id">{{c.displayName}}</option>
    </select>
  </div>

  <!-- Company display (Company Admin) -->
  <div class="form-row" *ngIf="!isGlobalAdmin">
    <label class="field-label">Company</label>
    <span class="field-value">{{clientDisplayName}}</span>
  </div>

  <!-- Date picker -->
  <div class="form-row">
    <label class="field-label">Archive schedules with Frac Start before</label>
    <input type="date" class="field-input" [(ngModel)]="beforeDate" (change)="reset()" />
  </div>

  <!-- Preview button -->
  <div class="action-row" *ngIf="!archiveComplete">
    <button class="btn btn-preview" (click)="preview()" [disabled]="isLoading || !beforeDate || !selectedClientId">
      {{isLoading ? 'Checking...' : 'Preview'}}
    </button>
  </div>

  <!-- Preview result -->
  <div class="preview-result" *ngIf="previewCount !== null && !archiveComplete">
    <div class="preview-count" *ngIf="previewCount > 0">
      <span class="count-highlight">{{previewCount}}</span> schedule(s) will be archived for
      <strong>{{clientDisplayName}}</strong>
      with Frac Start before <strong>{{beforeDate}}</strong>.
    </div>
    <div class="preview-count preview-empty" *ngIf="previewCount === 0">
      No schedules found matching the selected criteria.
    </div>
  </div>

  <!-- Confirm / Cancel -->
  <div class="action-row" *ngIf="previewCount !== null && previewCount > 0 && !archiveComplete && !pendingConfirm">
    <button class="btn btn-confirm" (click)="confirm()" [disabled]="isArchiving">
      {{isArchiving ? 'Archiving...' : 'Confirm Archive'}}
    </button>
    <button class="btn btn-cancel" (click)="reset()">Cancel</button>
  </div>

  <!-- Archive warning confirmation -->
  <div class="confirmation-warning" *ngIf="pendingConfirm">
    <p class="warning-text">
      <strong>Are you sure?</strong> Archiving these schedules will soft-delete them from view — no data will be lost.
      However, restoring archived schedules requires contacting support.
    </p>
    <div class="action-row">
      <button class="btn btn-confirm" (click)="proceedArchive()">Yes, Archive</button>
      <button class="btn btn-cancel" (click)="cancelConfirm()">Cancel</button>
    </div>
  </div>

  <!-- Success message -->
  <div class="success-message" *ngIf="archiveComplete">
    Successfully archived <strong>{{archivedCount}}</strong> schedule(s).
  </div>

  <!-- Close -->
  <div class="action-row close-row">
    <button class="btn btn-close" (click)="close()">Close</button>
  </div>
</div>
